import { Matrix } from "../../maths/Matrix";
import { Pool } from "../../utils/Pool";
export class TranslateCmd {
    static create(tx, ty) {
        var cmd = Pool.getItemByClass("TranslateCmd", TranslateCmd);
        cmd.tx = tx;
        cmd.ty = ty;
        return cmd;
    }
    recover() {
        Pool.recover("TranslateCmd", this);
    }
    run(context) {
        context.translate(this.tx, this.ty);
    }
    getBounds(assembler) {
        tempMatrix.identity();
        tempMatrix.translate(this.tx, this.ty);
        assembler.concatMatrix(tempMatrix);
    }
    get cmdID() {
        return TranslateCmd.ID;
    }
}
TranslateCmd.ID = "Translate";
const tempMatrix = new Matrix();
